export const defaultGridStyle = (width, columns) => { return  {
    display: "grid",
    position:'relative',
    width: width ?? '100%',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridGap: '5px',
    paddingTop: '10px',
    alignContent:'start'
}}
